import homeImg from '@/assets/images/home.png'
import styles from './index.module.scss'
import { useTranslation } from 'react-i18next'
const Home = () => {
  const { t } = useTranslation()
  return (
    <div className={styles.wscn_httphome_container}>
      <div className={styles.wscn_httphome}>
        <div className={styles.pic_home}>
          <img src={homeImg} alt="home" />
        </div>
        <div className={styles.bullshit}>
          <div className={styles.bullshit_oops}>
            <div> {t('layout.welcome1')}</div>
            <div> {t('layout.welcome2')}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Home
